import {isTimeType, TimeType} from '../../../types/TimeType';
import {DEFAULT_TIME_PICKER_STEP} from './getTimeOptions';

const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const FALLBACK_TIME: TimeType = '00:00';

export function getNextRoundedTime(now: Date, step = DEFAULT_TIME_PICKER_STEP): TimeType {
  const minutesOfDay = now.getHours() * MINUTES_PER_HOUR + now.getMinutes(); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  const lastBoundary = Math.floor((HOURS_PER_DAY * MINUTES_PER_HOUR - 1) / step) * step;
  const rounded = Math.min(Math.ceil(minutesOfDay / step) * step, lastBoundary);
  const hour = String(Math.floor(rounded / MINUTES_PER_HOUR)).padStart(2, '0');
  const minute = String(rounded % MINUTES_PER_HOUR).padStart(2, '0');
  const value = `${hour}:${minute}`;
  return isTimeType(value) ? value : FALLBACK_TIME;
}
